import React from "react"
import { router, usePage } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { X, Eye } from "lucide-react"
import { useToast } from "@/hooks/use-toast"

export function ImpersonationBanner() {
  const { props } = usePage()
  const { toast } = useToast()
  
  const { isImpersonating, originalUser, user } = props

  if (!isImpersonating || !originalUser) {
    return null
  }

  const handleStopImpersonation = () => {
    router.post('/impersonate/stop', {}, {
      onSuccess: (page) => {
        toast({
          title: "Success",
          description: "You are now viewing as yourself again.",
        })
        // Reload the page to refresh the view
        window.location.reload()
      },
      onError: (errors) => {
        toast({
          title: "Error",
          description: errors.message || "Failed to stop impersonation.",
          variant: "destructive",
        })
      }
    })
  }

  return (
    <div className="bg-amber-50 border-b border-amber-200 dark:bg-amber-700/20 dark:border-amber-800">
      <div className="flex items-center justify-between px-4 py-3 md:px-6">
        <div className="flex items-center gap-3">
          <Eye className="h-5 w-5 text-amber-600 dark:text-amber-400" />
          <div className="text-sm">
            <span className="font-medium text-amber-800 dark:text-amber-200">
              You are viewing as {user?.firstName} {user?.lastName}
            </span>
            <span className="text-amber-700 dark:text-amber-300 ml-1">
              (Original user: {originalUser.name})
            </span>
          </div>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={handleStopImpersonation}
          className="bg-white hover:bg-amber-50 border-amber-300 text-amber-800 hover:text-amber-900 dark:bg-amber-900/50 dark:hover:bg-amber-900/70 dark:border-amber-700 dark:text-amber-200 dark:hover:text-amber-100 text-xs sm:text-base"
        >
          <X className="h-4 w-4 mr-1 sm:mr-2" />
          Stop Viewing
        </Button>
      </div>
    </div>
  )
}
